import {createConsumer} from '@rails/actioncable'

const cable = createConsumer(process.env.REACT_APP_CABLE_URL) // Update with your production URL as needed

export default cable